export default [
  {
    title: 'menu.home',
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    title: 'menu.record-catches',
    route: 'record-catches-list',
    icon: 'AwardIcon',
    children: [
      {
        title: 'menu.list',
        route: 'record-catches',
        icon: 'CircleIcon',
        meta: {
          'role-method': 'list',
        },
      },
      {
        title: 'menu.overview',
        route: 'record-catch-overview',
        icon: 'CircleIcon',
        meta: {
          'role-method': 'list',
        },
      },
      {
        title: 'menu.add',
        route: 'add-record-catch',
        icon: 'CircleIcon',
        meta: {
          'role-method': 'create',
        },
      },
      {
        title: 'menu.import',
        route: 'record-catch-import',
        icon: 'CircleIcon',
        meta: {
          'role-method': 'create',
        },
      },
    ],
    meta: {
      role: 'record_catch',
    },
  },


  {
    title: 'menu.fishermen',
    route: 'fishermen',
    icon: 'UserIcon',
    children: [
      {
        title: 'menu.list',
        route: 'fishermen',
        icon: 'CircleIcon',
        meta: {
          'role-method': 'list',
        },
      },
      {
        title: 'menu.import',
        route: 'fishermen-import',
        icon: 'CircleIcon',
        meta: {
          'role-method': 'create',
        },
      },
    ],
    meta: {
      'role': 'fisherman',
    },
  },
  {
    title: 'menu.fish-categories',
    route: 'fish-categories',
    icon: 'FolderIcon',
    children: [
      {
        title: 'menu.list',
        route: 'fish-categories',
        icon: 'CircleIcon',
        meta: {
          'role-method': 'list',
        },
      },
      {
        title: 'menu.add',
        route: 'add-fish-category',
        icon: 'CircleIcon',
        meta: {
          'role-method': 'create',
        },
      },
    ],
    meta: {
      'role': 'fish_category',
    },
  },
  {
    title: 'menu.fish-types',
    route: 'fish-types',
    icon: 'ListIcon',
    children: [
      {
        title: 'menu.list',
        route: 'fish-types',
        icon: 'CircleIcon',
        meta: {
          'role-method': 'list',
        },
      },
      {
        title: 'menu.add',
        route: 'add-fish-type',
        icon: 'CircleIcon',
        meta: {
          'role-method': 'create',
        },
      },
    ],
    meta: {
      'role': 'fish_type',
    },
  },
  {
    title: 'menu.baits',
    route: 'baits',
    icon: 'FeatherIcon',
    children: [
      {
        title: 'menu.list',
        route: 'baits',
        icon: 'CircleIcon',
        meta: {
          'role-method': 'list',
        },
      },
      {
        title: 'menu.add',
        route: 'add-bait',
        icon: 'CircleIcon',
        meta: {
          'role-method': 'create',
        },
      },
    ],
    meta: {
      'role': 'bait',
    },
  },
  {
    title: 'menu.waters',
    route: 'waters',
    icon: 'DropletIcon',
    children: [
      {
        title: 'menu.list',
        route: 'waters',
        icon: 'CircleIcon',
        meta: {
          'role-method': 'list',
        },
      },
      {
        title: 'menu.sync',
        route: 'horinfo-sync',
        icon: 'CircleIcon',
        meta: {
          'role-method': 'list',
        },
      },
    ],
    meta: {
      'role': 'water',
    },
  },
  {
    title: 'menu.text-templates',
    route: 'text-templates',
    icon: 'TypeIcon',
    meta: {
      role: 'text_template',
      'role-method': 'list',
    },
  },
  {
    title: 'menu.email-templates',
    route: 'email-templates',
    icon: 'MailIcon',
    meta: {
      role: 'email_template',
      'role-method': 'list',
    },
  },
  {
    title: 'menu.users',
    route: 'user-list',
    icon: 'UsersIcon',
    children: [
      {
        title: 'menu.list',
        route: 'users',
        icon: 'CircleIcon',
        meta: {
          'role-method': 'list',
        },
      },
      {
        title: 'menu.add',
        route: 'add-user',
        icon: 'CircleIcon',
        meta: {
          'role-method': 'create',
        },
      },
    ],
    meta: {
      role: 'user',
    },
  },
  {
    title: 'menu.roles',
    route: 'role-list',
    icon: 'LockIcon',
    children: [
      {
        title: 'menu.list',
        route: 'roles',
        icon: 'CircleIcon',
        meta: {
          'role-method': 'list',
        },
      },
      {
        title: 'menu.add',
        route: 'add-role',
        icon: 'CircleIcon',
        meta: {
          'role-method': 'create',
        },
      },
    ],
    meta: {
      role: 'role',
    },
  },
  {
    title: 'menu.options',
    route: 'options',
    icon: 'SettingsIcon',
    meta: {
      role: 'option',
      'role-method': 'list',
    },
  },
]
